<template>
  <div>
    <div class="container mx-auto text-center">
      <div class="form-group admin-menu">
        <div class="flex space-x-2 overflow-x-auto pb-2">
          <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-square" @click="addRect(0, 0, 60, 60)">
            Masa
          </vs-button>
          <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-circle" @click="addCircle(0, 0, 30)">
            Masa
          </vs-button>
          <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-triangle" @click="addTriangle(0, 0, 30)">
            Masa
          </vs-button>
          <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-chair" @click="addChair(0, 0)">
            Sandalye
          </vs-button>
          <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-bar" @click="addBar(0, 0, 180, 60)">
            Bar
          </vs-button>
          <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-wall" @click="addWall(0, 0, 60, 180)">
            Duvar
          </vs-button>
          <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash" @click="removeObject">
            Sil
          </vs-button>
          <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-user" @click="toggleCustomerMode">
            Sıcak Satış Görünüşü
          </vs-button>
          <vs-button type="gradient" color="info" icon-pack="feather" icon="icon-save" @click="saveObjects">
            Kaydet
          </vs-button>
          <vs-button type="gradient" color="warning" icon-pack="feather" icon="icon-zoom-in" @click="zoomIn">
           
          </vs-button>
          <vs-button type="gradient" color="warning" icon-pack="feather" icon="icon-zoom-out" @click="zoomOut">
           
          </vs-button>
        </div>
      </div>
      
      <div class="form-group customer-menu" v-show="isCustomerMode">
        <div class="btn-group">
          <button class="btn btn-success submit" >Submit reservation</button>
          <button class="btn btn-warning admin-mode" @click="toggleAdminMode">Admin mode</button>
        </div>
      </div>
      
      <div class="canvas-wrapper" :class="{ 'customer-mode': isCustomerMode }" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @scroll="handleScroll">
        <canvas id="canvas" :width="width" :height="height"></canvas>
      </div>
      
      <div class="minimap-wrapper" @mousedown="handleMinimapMouseDown" @mousemove="handleMinimapMouseMove" @mouseup="handleMinimapMouseUp" @mouseleave="handleMinimapMouseUp">
        <canvas id="minimap" :width="minimapWidth" :height="minimapHeight"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
import { fabric } from 'fabric';
export default {
  data() {
    return {
      canvas: null,
      minimap: null,
      number: 1,
      width: 2000,
      height: 2000,
      minimapWidth: 200,
      minimapHeight: 200,
      isCustomerMode: false,
      modalText: '',
      grid: 30,
      backgroundColor: '#f8f8f8',
      lineStroke: '#ebebeb',
      tableFill: 'rgba(150, 111, 51, 0.7)',
      tableStroke: '#694d23',
      tableShadow: 'rgba(0, 0, 0, 0.4) 3px 3px 7px',
      chairFill: 'rgba(67, 42, 4, 0.7)',
      chairStroke: '#32230b',
      chairShadow: 'rgba(0, 0, 0, 0.4) 3px 3px 7px',
      barFill: 'rgba(0, 93, 127, 0.7)',
      barStroke: '#003e54',
      barShadow: 'rgba(0, 0, 0, 0.4) 3px 3px 7px',
      barText: 'Bar',
      wallFill: 'rgba(136, 136, 136, 0.7)',
      wallStroke: '#686868',
      wallShadow: 'rgba(0, 0, 0, 0.4) 5px 5px 20px',
      contextMenuVisible: false,
      contextMenuX: 0,
      contextMenuY: 0,
      touchStartX: 0,
      touchStartY: 0,
      viewportLeft: 0,
      viewportTop: 0,
      zoomLevel: 1,
      isDraggingMinimap: false,
      minimapDragStartX: 0,
      minimapDragStartY: 0
    };
  },
  mounted() {
    this.initCanvas();
    this.$nextTick(() => {
      this.initMinimap();
    });
    window.addEventListener('keydown', this.handleKeyDown);
    this.loadObjects();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    initCanvas() {
      if (this.canvas) {
        this.canvas.clear();
        this.canvas.dispose();
      }

      this.canvas = new fabric.Canvas('canvas');
      this.number = 1;
      this.canvas.backgroundColor = this.backgroundColor;

      for (let i = 0; i < (this.canvas.height / this.grid); i++) {
        const lineX = new fabric.Line([0, i * this.grid, this.canvas.height, i * this.grid], {
          stroke: this.lineStroke,
          selectable: false,
          type: 'line'
        });
        const lineY = new fabric.Line([i * this.grid, 0, i * this.grid, this.canvas.height], {
          stroke: this.lineStroke,
          selectable: false,
          type: 'line'
        });
        this.sendLinesToBack();
        this.canvas.add(lineX);
        this.canvas.add(lineY);
      }

      this.canvas.on('object:moving', (e) => {
        this.snapToGrid(e.target);
        this.checkBoundingBox(e);
        this.updateMinimap();
      });

      this.canvas.on('object:scaling', (e) => {
        this.checkBoundingBox(e);
        this.updateMinimap();
      });

      this.canvas.on('object:modified', (e) => {
        this.snapToGrid(e.target);
        if (e.target.type === 'table') {
        if (!e.target.strokeWidthUnscaled && e.target.strokeWidth) {
          e.target.strokeWidthUnscaled = e.target.strokeWidth;
        }
        if (e.target.strokeWidthUnscaled) {
          e.target.strokeWidth = e.target.strokeWidthUnscaled / e.target.scaleX;
          if (e.target.strokeWidth === e.target.strokeWidthUnscaled) {
            e.target.strokeWidth = e.target.strokeWidthUnscaled / e.target.scaleY;
          }
        }
        this.checkBoundingBox(e);
      }
        this.updateMinimap();
      });

      this.canvas.on('object:modified', (e) => {
        this.snapToGrid(e.target);
        if (e.target.type === 'table') {
          this.canvas.bringToFront(e.target);
        } else {
          this.canvas.sendToBack(e.target);
        }
        this.sendLinesToBack();
        this.checkBoundingBox(e);
        this.updateMinimap();
      });

      this.canvas.observe('object:moving', (e) => {
        this.checkBoundingBox(e);
        this.updateMinimap();
      });
      this.canvas.observe('object:rotating', (e) => {
        this.checkBoundingBox(e);
        this.updateMinimap();
      });
      this.canvas.observe('object:scaling', (e) => {
        this.checkBoundingBox(e);
        this.updateMinimap();
      });

      this.canvas.on('mouse:down', (e) => {
        if (this.isCustomerMode && e.target && e.target.isTable) {
          console.log(`Masa ID: ${e.target.id}`);
        }
      });

      //this.addDefaultobjects();
    },
    initMinimap() {
      const minimapElement = document.getElementById('minimap');
      if (minimapElement) {
        this.minimap = new fabric.StaticCanvas('minimap');
        this.minimap.backgroundColor = this.backgroundColor;
        this.updateMinimap();
      } else {
        console.error('Minimap element not found');
      }
    },
    updateMinimap() {
      if (!this.minimap) {
        console.error('Minimap not initialized');
        return;
      }
      this.minimap.clear();
      const scale = this.minimapWidth / this.width;
      this.canvas.getObjects().forEach(obj => {
        if (obj.type !== 'line') {
          const clonedObj = fabric.util.object.clone(obj);
          clonedObj.set({
            left: obj.left * scale,
            top: obj.top * scale,
            scaleX: obj.scaleX * scale,
            scaleY: obj.scaleY * scale,
            width: obj.width * scale,
            height: obj.height * scale,
            selectable: false,
            evented: false
          });
          this.minimap.add(clonedObj);
        }
      });
      
      // Viewport rectangle
      const viewportRect = new fabric.Rect({
        left: this.viewportLeft * scale,
        top: this.viewportTop * scale,
        width: this.minimapWidth * (window.innerWidth / (this.width * this.zoomLevel)),
        height: this.minimapHeight * (window.innerHeight / (this.height * this.zoomLevel)),
        fill: 'rgba(255, 0, 0, 0.3)',
        stroke: 'red',
        strokeWidth: 2
      });
      this.minimap.add(viewportRect);
      
      this.minimap.renderAll();
    },
    handleMinimapMouseDown(event) {
      this.isDraggingMinimap = true;
      this.minimapDragStartX = event.clientX;
      this.minimapDragStartY = event.clientY;
      this.moveViewportFromMinimap(event);
    },
    handleMinimapMouseMove(event) {
      if (this.isDraggingMinimap) {
        this.moveViewportFromMinimap(event);
      }
    },
    handleMinimapMouseUp() {
      this.isDraggingMinimap = false;
    },
    moveViewportFromMinimap(event) {
      const minimapRect = event.target.getBoundingClientRect();
      const scaleX = this.width / this.minimapWidth;
      const scaleY = this.height / this.minimapHeight;
      
      const canvasWrapper = document.querySelector('.canvas-wrapper');
      const newLeft = (event.clientX - minimapRect.left) * scaleX - (window.innerWidth / 2);
      const newTop = (event.clientY - minimapRect.top) * scaleY - (window.innerHeight / 2);
      
      canvasWrapper.scrollLeft = newLeft;
      canvasWrapper.scrollTop = newTop;
      
      this.viewportLeft = canvasWrapper.scrollLeft;
      this.viewportTop = canvasWrapper.scrollTop;
      this.updateMinimap();
    },
    resizeCanvas() {
      this.canvas.setWidth(this.width);
      this.canvas.setHeight(this.height);
      const canvasContainerEl = document.querySelector('.canvas-container');
      canvasContainerEl.style.width = `${this.width}px`;
      canvasContainerEl.style.height = `${this.height}px`;
      this.updateMinimap();
    },
    saveCanvas() {
      this.resizeCanvas();
      this.initCanvas();
    },
    generateId() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    addRect(left, top, width, height) {
      const id = this.generateId();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: this.tableFill,
        stroke: this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: 'center',
        originY: 'center',
        centeredRotation: true,
        snapAngle: 45,
        selectable: true
      });
      const t = new fabric.IText(this.number.toString(), {
        fontFamily: 'Calibri',
        fontSize: 14,
        fill: '#fff',
        textAlign: 'center',
        originX: 'center',
        originY: 'center'
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: 'group',
        isTable: true,
        id: id,
        number: this.number
      });
      this.canvas.add(g);
      this.number++;
      this.updateMinimap();
      return g;
    },
    addCircle(left, top, radius) {
      const id = this.generateId();
      const o = new fabric.Circle({
        radius: radius,
        fill: this.tableFill,
        stroke: this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: 'center',
        originY: 'center',
        centeredRotation: true
      });
      const t = new fabric.IText(this.number.toString(), {
        fontFamily: 'Calibri',
        fontSize: 14,
        fill: '#fff',
        textAlign: 'center',
        originX: 'center',
        originY: 'center'
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: 'group',
        id: id,
        isTable: true,
        number: this.number
      });
      this.canvas.add(g);
      this.number++;
      this.updateMinimap();
      return g;
    },
    addTriangle(left, top, radius) {
      const id = this.generateId();
      const o = new fabric.Triangle({
        radius: radius,
        fill: this.tableFill,
        stroke: this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: 'center',
        originY: 'center',
        centeredRotation: true
      });
      const t = new fabric.IText(this.number.toString(), {
        fontFamily: 'Calibri',
        fontSize: 14,
        fill: '#fff',
        textAlign: 'center',
        originX: 'center',
        originY: 'center'
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: 'group',
        isTable: true,
        id: id,
        number: this.number
      });
      this.canvas.add(g);
      this.number++;
      this.updateMinimap();
      return g;
    },
    addChair(left, top, width = 30, height = 30) {
      const id = this.generateId();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: this.chairFill,
        stroke: this.chairStroke,
        strokeWidth: 2,
        shadow: this.chairShadow,
        originX: 'center',
        originY: 'center',
        centeredRotation: true,
        snapAngle: 45,
        selectable: true
      });
      const t = new fabric.IText("", {
        fontFamily: 'Calibri',
        fontSize: 14,
        fill: this.chairFill,
        textAlign: 'center',
        originX: 'center',
        originY: 'center'
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: 'group',
        isTable: false,
        id: id,
        number:0
      });
      this.canvas.add(g);
      this.updateMinimap();
      return g;
    },
    addBar(left, top, width, height) {
      const id = this.generateId();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: this.barFill,
        stroke: this.barStroke,
        strokeWidth: 2,
        shadow: this.barShadow,
        originX: 'center',
        originY: 'center',
        centeredRotation: true,
        snapAngle: 45,
        selectable: true
      });
      const t = new fabric.IText(this.barText, {
        fontFamily: 'Calibri',
        fontSize: 14,
        fill: '#fff',
        textAlign: 'center',
        originX: 'center',
        originY: 'center'
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: 'group',
        isTable: false,
        id: id,
        number:0
      });
      this.canvas.add(g);
      this.updateMinimap();
      return g;
    },
    addWall(left, top, width, height) {
      const id = this.generateId();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: this.wallFill,
        stroke: this.wallStroke,
        strokeWidth: 2,
        shadow: this.wallShadow,
        originX: 'center',
        originY: 'center',
        centeredRotation: true,
        snapAngle: 45,
        selectable: true
      });
      const t = new fabric.IText('Duvar', {
        fontFamily: 'Calibri',
        fontSize: 14,
        fill: this.wallFill,
        textAlign: 'center',
        originX: 'center',
        originY: 'center'
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: 'group',
        isTable: false,
        id: id,
        number: 0
      });
      this.canvas.add(g);
      this.updateMinimap();
      return g;
    },
    snapToGrid(target) {
      target.set({
        left: Math.round(target.left / this.grid) * this.grid,
        top: Math.round(target.top / this.grid) * this.grid
      });
    },
    checkBoundingBox(e) {
      const obj = e.target;

      if (!obj) {
        return;
      }
      obj.setCoords();

      const objBoundingBox = obj.getBoundingRect();
      if (objBoundingBox.top < 0) {
        obj.set('top', 0);
        obj.setCoords();
      }
      if (objBoundingBox.left > this.canvas.width - objBoundingBox.width) {
        obj.set('left', this.canvas.width - objBoundingBox.width);
        obj.setCoords();
      }
      if (objBoundingBox.top > this.canvas.height - objBoundingBox.height) {
        obj.set('top', this.canvas.height - objBoundingBox.height);
        obj.setCoords();
      }
      if (objBoundingBox.left < 0) {
        obj.set('left', 0);
        obj.setCoords();
      }
    },
    sendLinesToBack() {
      this.canvas.getObjects().map(o => {
        if (o.type === 'line') {
          this.canvas.sendToBack(o);
        }
      });
    },
    removeObject() {
      const o = this.canvas.getActiveObject();
      if (o) {
        o.remove();
        this.canvas.remove(o);
        this.canvas.discardActiveObject();
        this.canvas.renderAll();
      }
      this.contextMenuVisible = false;
      this.updateMinimap();
    },
    toggleCustomerMode() {
      this.canvas.getObjects().map(o => {
        o.hasControls = false;
        o.lockMovementX = true;
        o.lockMovementY = true;
        if (o.isTable == false) {
          o.selectable = false;
        }
        o.borderColor = 'green';
        o.borderScaleFactor = 20.5;
      });
      this.canvas.selection = false;
      this.canvas.hoverCursor = 'pointer';
      this.canvas.discardActiveObject();
      this.canvas.renderAll();
      this.isCustomerMode = true;
      this.updateMinimap();
    },
    toggleAdminMode() {
      this.canvas.getObjects().map(o => {
        o.hasControls = true;
        o.lockMovementX = false;
        o.lockMovementY = false;
        if (o.type === 'chair' || o.type === 'bar' || o.type === 'wall') {
          o.selectable = true;
        }
        o.borderColor = 'rgba(102, 153, 255, 0.75)';
        o.borderScaleFactor = 1;
      });
      this.canvas.selection = true;
      this.canvas.hoverCursor = 'move';
      this.canvas.discardActiveObject();
      this.canvas.renderAll();
      this.isCustomerMode = false;
      this.updateMinimap();
    },
    handleKeyDown(event) {
      const activeObject = this.canvas.getActiveObject();
      if (!activeObject) return;

      switch (event.key) {
        case 'ArrowUp':
          activeObject.top -= this.grid;
          break;
        case 'ArrowDown':
          activeObject.top += this.grid;
          break;
        case 'ArrowLeft':
          activeObject.left -= this.grid;
          break;
        case 'ArrowRight':
          activeObject.left += this.grid;
          break;
        case 'Delete':
          this.removeObject();
          break;
        case 'Escape': // Esc key
          this.canvas.discardActiveObject();
          this.canvas.renderAll();
          break;
        case 'Enter':
          const center = activeObject.getCenterPoint();
          activeObject.rotate((activeObject.angle + 45) % 360);
          //activeObject.setPositionByOrigin(center, 'center', 'center');
          break;
        default:
          return;
      }
      console.log('derlendi');
      activeObject.setCoords();
      this.checkBoundingBox({ target: activeObject });
      this.canvas.renderAll();
      this.updateMinimap();
      event.preventDefault();
    },
    saveObjects() {
      console.log('save button clicked');
      try {
        const json = JSON.stringify(this.canvas.toObject(['id','isTable', 'number']));
        console.log(json);
        localStorage.setItem('restaurantLayout', json);
        alert('Layout saved successfully!');
      } catch (error) {
        console.error('Error saving layout:', error);
        alert('Failed to save layout. Please try again.');
      }
    },
    loadObjects() {
      const json = localStorage.getItem('restaurantLayout');
      if (json) {
        try {
          const parsedJson = JSON.parse(json);
          this.canvas.loadFromJSON(parsedJson, () => {
            this.canvas.renderAll();
            this.updateMinimap();
          });
        } catch (error) {
          console.log('Error loading layout:'+ error);
        }
      }
    },
    handleTouchStart(event) {
      if (this.isCustomerMode) {
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
      }
    },
    handleTouchMove(event) {
      if (this.isCustomerMode) {
        const touchX = event.touches[0].clientX;
        const touchY = event.touches[0].clientY;
        const deltaX = this.touchStartX - touchX;
        const deltaY = this.touchStartY - touchY;

        const canvasWrapper = event.currentTarget;
        canvasWrapper.scrollLeft += deltaX;
        canvasWrapper.scrollTop += deltaY;

        this.touchStartX = touchX;
        this.touchStartY = touchY;

        // Update viewport position for minimap
        this.viewportLeft = canvasWrapper.scrollLeft;
        this.viewportTop = canvasWrapper.scrollTop;
        this.updateMinimap();
      }
    },
    handleScroll(event) {
      const canvasWrapper = event.target;
      this.viewportLeft = canvasWrapper.scrollLeft;
      this.viewportTop = canvasWrapper.scrollTop;
      this.updateMinimap();
    },
    zoomIn() {
      this.zoomLevel *= 1.1;
      this.canvas.setZoom(this.zoomLevel);
      this.canvas.setWidth(this.width * this.zoomLevel);
      this.canvas.setHeight(this.height * this.zoomLevel);
      this.canvas.renderAll();
      this.updateMinimap();
    },
    zoomOut() {
      this.zoomLevel /= 1.1;
      this.canvas.setZoom(this.zoomLevel);
      this.canvas.setWidth(this.width * this.zoomLevel);
      this.canvas.setHeight(this.height * this.zoomLevel);
      this.canvas.renderAll();
      this.updateMinimap();
    }
  }
};
</script>

<style>
body {
  margin-top: 30px;
  margin-bottom: 30px;
  background: #f2f2f2;
}

.canvas-wrapper {
  overflow-x: auto;
  width: 100%;
  overflow-y: auto;
  max-width: 100%;
  max-height: calc(100vh - 200px);
}

.canvas-wrapper.customer-mode {
  touch-action: pan-x pan-y;
}

.canvas-container {
  margin-right: auto;
  margin-left: auto;
}

.minimap-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  border: 2px solid #333;
  background-color: rgba(255, 255, 255, 0.8);
  cursor: move;
}

@media (max-width: 768px) {
  .canvas-wrapper {
    max-height: calc(100vh - 150px);
  }
}

</style>